const client = axios.create({
    baseURL: '/api',
})

client.interceptors.response.use((response) => {
    if (response.data.type !== undefined && response.data.type === 'notification') {
        console.log('client', response.data)
        emitter.emit('notify', response.data);
    }
    return response;
}, (error) => {
    if (error.response && error.response.data != undefined && error.response.status === 422) {
        console.log('client', error.response.data);
        emitter.emit('validationError', {error: error.response.data})
    }
    if (error.response && error.response.data != undefined && error.response.status === 403) {
        console.log(error.response.data.message);
        emitter.emit('validationError', {error: {errors: [[error.response.data.message]]}});
    } else if (error.response && error.response.data != undefined && error.response.status === 429) {
        console.log(error.response.data.message);
        emitter.emit('validationError', {error: {errors: [[error.response.data.message]]}});
    } else if (error.response && error.response.status === 401) {
        emitter.emit('openLoginModal');
    } else if (error.response && error.response.status === 404) {
        emitter.emit('pageNotFound');
    }
    emitter.emit('loading', false);
    return Promise.reject(error);
});

export default client;
